package com.swetdot.swetgram.data.cache

import app.cash.sqldelight.db.SqlDriver
import com.swetdot.swetgram.cache.SwetgramCache

/**
 * Opening a SQLite database is the one part of the cache that genuinely differs per platform:
 * Android needs a `Context`, iOS does not. Everything above this line is shared.
 */
expect class DatabaseDriverFactory {
    fun create(): SqlDriver
}

const val DATABASE_NAME = "swetgram.db"

fun createCache(factory: DatabaseDriverFactory): SwetgramCache =
    SwetgramCache(factory.create())
